import WalterLoader from '../components/shared/WalterLoader';
import { STAFF_ROLES, useAuth } from './AuthContext';
import AuthCard from './AuthCard';
import LoginForm from './LoginForm';
import ReconnectModal from './ReconnectModal';
import '../styles/Auth.css';

// Pages accessibles sans compte (routes déclarées dans App.js).
const PUBLIC_PATH = /^\/(login|mot-de-passe-oublie|invitation\/[^/]+|reset\/[^/]+)\/?$/;

// Garde de l'application (AUTH_PLAN.md §5.3), placée autour du router. Tant que l'API est en
// AUTH_ENABLED=false, elle ne bloque rien. Ensuite : un visiteur anonyme voit l'écran de
// connexion à la place de la page (l'URL est conservée, il y revient une fois connecté), et un
// compte client voit un écran d'attente jusqu'à l'ouverture de l'accès client (étape 6).
// La modale de reconnexion (session expirée en cours de route) s'affiche par-dessus la page.
export default function AuthGate({ children }) {
    const { status, user, authEnabled, reconnectOpen, closeLogin } = useAuth();

    if (status === 'loading') {
        return (
            <div className="auth-page">
                <WalterLoader />
            </div>
        );
    }

    let content = children;
    if (authEnabled && !PUBLIC_PATH.test(window.location.pathname)) {
        if (!user) {
            content = (
                <AuthCard title="Connexion" subtitle="Connectez-vous pour accéder à Walter.">
                    <LoginForm />
                </AuthCard>
            );
        } else if (!STAFF_ROLES.includes(user.role)) {
            content = <ClientPendingScreen />;
        }
    }

    return (
        <>
            {content}
            {reconnectOpen && <ReconnectModal onClose={closeLogin} />}
        </>
    );
}

function ClientPendingScreen() {
    const { user, logout } = useAuth();
    const handleLogout = async () => {
        const result = await logout().catch((error) => ({ error }));
        if (result.blocked) window.alert(`${result.blocked} modification(s) pas encore synchronisée(s) : reconnectez-vous au réseau avant de vous déconnecter.`);
        else if (result.error) window.alert(result.error.message);
    };
    return (
        <AuthCard
            title={`Bonjour ${user.name}`}
            subtitle="Votre compte est prêt. L'accès client à Walter ouvre prochainement : vous serez prévenu dès qu'il sera disponible."
        >
            <button type="button" className="auth-btn auth-btn--secondary" onClick={handleLogout}>Se déconnecter</button>
        </AuthCard>
    );
}
